import React, {Component} from 'react'
import Inputs from '../../shared/FormComponents/Inputs'
import { Link } from 'react-router-dom';
import _ from 'lodash';
import './ForgotPassword.css'

export default class Login extends Component {
    constructor(props) {
      super(props);
      this.state = {
        loginData: {
            email: false,
        },
        inputStates: {
            email: false
        },
        loading: false,
      };
    }
  
    componentWillReceiveProps(nextProps) {
      this.setState({ loading: nextProps.loading });
    }
  
    componentWillUnmount () {
      this.setState({ loading:false })
    }
  
    onForgotPassword = () => {
      this.props.onForgotPassword(this.state.loginData.email);
    }

    onDataChange = (key, value, valid) => {
        const state = _.extend({}, this.state);
        state.inputStates[key] = valid;
        state.loginData[key] = value;
        this.setState(state, () => this.validateForm());
    };

    validateForm = () => {
        let validationStates = _.extend({}, this.state.inputStates);
        let key = Object.values(validationStates).indexOf(false) !== -1;
        let state = !key;
        this.setState({ formValid: state });
    }



    render() {
        return (
            <div className="forgot-password-content">
                <div className="forgot-password-content-layout">

                    <div className="card">
                        <div className='card-header'>
                            <div className="logo-bg-layout">
                                <div className='login-logo-box'></div>
                            </div>
                        </div>
                        <div className="card-body">
                            
                            <form>
                                <div className="form-group icon-input">
                                    <i class="fas fa-envelope"></i>
                                    <Inputs
                                        type="login"
                                        className="form-control"
                                        value={this.state.loginData.email}
                                        required={ true }
                                        placeholder='Email'
                                        // onChange={ (value, valid) => this.onDataChange('username', value, valid)}
                                        onChange={ (value, valid) => this.onDataChange('email', value, valid)}
                                        />
                                </div>
                                <button
                                    type="button"
                                    onClick={this.onForgotPassword}
                                    disabled={!this.state.formValid || this.props.forgotPasswordPending}
                                    className="btn forgot-password-button">
                                    Reset
                                    {this.props.forgotPasswordPending && <i className="fa fa-spinner fa-spin fa-3x fa-fw"></i>}
                                </button>
                                <div className="btn empty-btn default"><Link to='/login'>Back</Link></div>
                            </form>
                        </div>

                    </div> 
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/ForgotPassword/ForgotPassword.jsx